module.exports = __webpack_public_path__ + "static/img/logo.e522e8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 8